import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
////import
import PageChange from '../../../pageChange/index'
import Layout from "../../../component/Layout/Layout";
import BusinessOrder from '../../../component/dashboard/addOrder/businessOrder';
import FreeOrder from '../../../component/dashboard/addOrder/freeOrder';
import PersonalOrder from '../../../component/dashboard/addOrder/personalOrder';


function IndexAdd() {
    const [isDataLoad, setIsDataLoad] = useState(false);
    const { language } = useSelector((item) => item.user)


    const [freePrice, setFreePrice] = useState(0);
    const [businessPrice, setBusinessPrice] = useState(0);
    const [personalOrder, setPersonalOrder] = useState(0);



    const [bodyWidth, setBodyWidth] = useState(null);


    useEffect(() => {
        const handleResize = () => {
            setBodyWidth(document.body.offsetWidth);
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleResize = (bodyWidth) => {
        if (bodyWidth < 1024) {
            return "max-w-screen-2xl  px-6 sm:px-8 lg:px-16 mx-auto";
        } else {
            return 1
        }
    };


    useEffect(() => {
        handleResize(bodyWidth)
    }, []);



    useEffect(() => {
        getPrice(language)
    }, [])



    async function getPrice(langs) {

        const result = await fetch(`${process.env.REACT_APP_SERVER}/api/setting`, {
            method: "GET",
            headers: {
                lang: langs
            }
        })

        const res = await result.json()
        if (res?.status == "success") {
            setIsDataLoad(true)
            setFreePrice(res?.data.price_free)
            setBusinessPrice(res?.data.price_business)
            setPersonalOrder(res?.data.price_personal)
        }


        return

    }

    return (
        <>
            {isDataLoad ? (
                <>
                    <Layout />

                    <div className='mb-24 space-y-8 lg:flex lg:justify-center lg:gap-10 lg:space-y-0 lg:mt-40'>

                        <FreeOrder handleResize={handleResize(bodyWidth)} freePrice={freePrice} />
                        <BusinessOrder handleResize={handleResize(bodyWidth)} businessPrice={businessPrice} />
                        <PersonalOrder handleResize={handleResize(bodyWidth)} personalOrder={personalOrder} />
                    </div>



                </>
            ) : (
                <PageChange />
            )
            }
        </>
    );
}

export default IndexAdd;
